__turbopack_context__.v({
  "container": "Media-module-scss-module__wMQiVW__container",
  "image": "Media-module-scss-module__wMQiVW__image",
});
